var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.47917 1.16663C6.47917 0.717895 6.1154 0.354126 5.66667 0.354126C5.21794 0.354126 4.85417 0.717895 4.85417 1.16663V2.79163L4.58333 2.79163C2.1901 2.79163 0.25 4.73173 0.25 7.12496L0.25 7.93746L19.75 7.93746V7.12496C19.75 4.73173 17.8099 2.79163 15.4167 2.79163H15.1458V1.16663C15.1458 0.717895 14.7821 0.354126 14.3333 0.354126C13.8846 0.354126 13.5208 0.717895 13.5208 1.16663V2.79163H6.47917V1.16663ZM0.25 9.56246L19.75 9.56246V18.5C19.75 20.8932 17.8099 22.8333 15.4167 22.8333H4.58333C2.1901 22.8333 0.25 20.8932 0.25 18.5L0.25 9.56246Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar2);
export default __webpack_public_path__ + "static/media/calendar-2.5b0f087f2b54f38197f8a58e2f071bac.svg";
export { ForwardRef as ReactComponent };